import axios from 'axios';
import { getAuthToken } from '../utils/auth';

const apiClient = axios.create({
  baseURL: '/api',
  timeout: 30000, // Increased timeout for mobile connections
  headers: { 
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache'
  },
  // Add retry configuration for mobile networks
  retry: 3,
  retryDelay: 1000,
});

apiClient.interceptors.request.use(config => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    delete config.headers.Authorization;
  }
  console.log('Request Details:', {
    url: config.baseURL + config.url,
    fullUrl: window.location.origin + config.baseURL + config.url,
    headers: config.headers,
    data: config.data,
  });
  return config;
});

apiClient.interceptors.response.use(
  response => response,
  async error => {
    console.error('API Error:', {
      message: error.message,
      code: error.code,
      response: error.response ? {
        status: error.response.status,
        data: error.response.data,
      } : null,
    });

    // Retry logic for mobile network issues
    const config = error.config;
    if (config && config.retry > 0 && (
      error.code === 'ECONNABORTED' || 
      error.code === 'NETWORK_ERROR' ||
      error.message === 'Network Error' ||
      (error.response && [502, 503, 504].includes(error.response.status))
    )) {
      config.retry -= 1;
      console.log(`Retrying request... Attempts left: ${config.retry}`);
      
      // Wait before retrying
      await new Promise(resolve => setTimeout(resolve, config.retryDelay || 1000));
      
      return apiClient(config);
    }

    return Promise.reject(error);
  }
);

export default apiClient;